import { Component } from 'react';
import HoldingLayout from './HoldingLayout';
import { ContactUsForm } from './ContactUsForm';

class ThemedContact extends Component {
  render() {
    return (
      <HoldingLayout>
        <section className="h-page-hero h-page-hero-sm">
          <div className="h-hero-bg-pattern" aria-hidden="true" />
          <div className="h-section-inner">
            <div className="h-page-hero-content">
              <h1 className="h-page-hero-title">Contact Us</h1>
              <p className="h-page-hero-desc">
                Have a question or want to work with us? We'd love to hear from you.
              </p>
            </div>
          </div>
        </section>
        <section className="h-page-contact">
          <div className="h-section-inner">
            <div className="h-contact-grid">
              <div className="h-contact-form-wrap">
                <ContactUsForm />
              </div>
              <div className="h-contact-info">
                <div className="h-contact-info-card">
                  <h3 className="h-contact-info-title">Get in touch</h3>
                  <div className="h-contact-detail">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                    <a href="mailto:info@rakeen.cc">info@rakeen.cc</a>
                  </div>
                  <div className="h-contact-detail">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    <span>Khobar, Saudi Arabia</span>
                  </div>
                  <div className="h-contact-detail">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                    <span>Response within 1-2 business days</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </HoldingLayout>
    );
  }
}

export default ThemedContact;
